import { DocLibraryEntry } from './docLibraryItem'

export const filterByNeedUpload = (e: DocLibraryEntry) => !e.fileGroup

export const filterByAlreadyUploaded = (e: DocLibraryEntry) => !!e.fileGroup
